module.exports = __webpack_public_path__ + "img/root111.45469688.png";